import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingDown } from 'lucide-react';
const stages = [{
  id: 1,
  title: 'Pre-Congress',
  subtitle: 'Agenda Setting',
  goal: 'Create awareness & curiosity, set problems to explore',
  conversion: '100%',
  color: '#E60012',
  opacity: 1
}, {
  id: 2,
  title: 'Vicinity',
  subtitle: 'Brand Nudging',
  goal: 'Encourage booth visit as they approach venue',
  conversion: '65%',
  color: '#E60012',
  opacity: 0.85
}, {
  id: 3,
  title: 'Venue',
  subtitle: 'Repeat Agenda',
  goal: 'Re-activate problem, remind of booth location',
  conversion: '45%',
  color: '#E60012',
  opacity: 0.7
}, {
  id: 4,
  title: 'Aisle',
  subtitle: 'Break the Barrier',
  goal: 'Non-committed engagement at their own pace',
  conversion: '25%',
  color: '#E60012',
  opacity: 0.55
}, {
  id: 5,
  title: 'Booth',
  subtitle: 'Cross the Border',
  goal: 'Deep face-to-face engagement & conversion',
  conversion: '15%',
  color: '#E60012',
  opacity: 0.4
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function SlideOverview() {
  return <div className="h-full w-full bg-[#FDF8F8] text-[#2D2926] p-12 md:p-16 flex flex-col" data-id="element-542">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="mb-12 text-center" data-id="element-543">
        <h2 className="text-4xl font-bold text-[#2D2926] mb-4" data-id="element-544">
          The Congress Conversion Funnel
        </h2>
        <p className="text-xl text-[#E60012] mb-2" data-id="element-545">
          5 stages from awareness to booth engagement
        </p>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-546">
          <TrendingDown className="w-4 h-4 text-[#E60012]" data-id="element-547" />
          <span data-id="element-548">Each stage requires a different engagement strategy</span>
        </div>
      </motion.div>

      <div className="flex-1 flex items-center justify-center" data-id="element-549">
        <motion.div className="grid grid-cols-1 gap-4 max-w-4xl w-full" variants={container} initial="hidden" animate="show" data-id="element-550">
          {stages.map((stage, index) => {
          const barWidth = parseInt(stage.conversion);
          return <motion.div key={stage.id} variants={item} className="relative" data-id="element-551">
                <div className="flex items-center gap-4" data-id="element-552">
                  {/* Stage number */}
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#E60012] text-white flex items-center justify-center font-bold text-lg shadow-lg" data-id="element-553">
                    {stage.id}
                  </div>

                  {/* Funnel bar */}
                  <div className="flex-1" data-id="element-554">
                    <div className="mb-1 flex items-baseline justify-between" data-id="element-555">
                      <div data-id="element-556">
                        <span className="font-bold text-lg text-[#2D2926]" data-id="element-557">
                          {stage.title}
                        </span>
                        <span className="text-sm text-[#E60012] ml-2" data-id="element-558">
                          {stage.subtitle}
                        </span>
                      </div>
                      <span className="text-sm font-semibold text-[#E60012]" data-id="element-559">
                        {stage.conversion}
                      </span>
                    </div>
                    <div className="h-16 bg-gray-100 rounded-lg overflow-hidden relative" data-id="element-560">
                      <motion.div className="h-full rounded-lg flex items-center px-4" style={{
                    backgroundColor: stage.color,
                    opacity: stage.opacity
                  }} initial={{
                    width: 0
                  }} animate={{
                    width: `${barWidth}%`
                  }} transition={{
                    duration: 0.8,
                    delay: 0.3 + index * 0.1,
                    ease: 'easeOut'
                  }} data-id="element-561">
                        <p className="text-white text-sm font-medium leading-tight" data-id="element-562">
                          {stage.goal}
                        </p>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>

      <motion.div className="mt-8 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5
    }} data-id="element-563">
        <img src="https://cdn.magicpatterns.com/uploads/1b359RHXQpSxudE5Uv3MYK/Screenshot_2026-04-01_at_09.07.26.png" alt="Nested zone diagram showing Pre-Congress, Vicinity, Venue, Aisle, and Booth" className="w-full max-w-2xl mx-auto h-auto object-contain opacity-80" data-id="element-564" />
      </motion.div>
    </div>;
}